// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__ty3IZ","white":"Loading_white__orS6-","spinner":"Loading_spinner__YGLIk","crl":"Loading_crl__nObdF","small":"Loading_small__VFLsD"};